import React, { memo, ReactNode } from 'react'
import tw from 'twin.macro'
import { TableTab } from './TableTab'

export interface TableTabItem<V> {
  title: string
  value: V
  subtitle?: string
  renderIcon(selected: boolean): ReactNode
  dataTestId?: string
}

interface Props<V> {
  tabs: Array<TableTabItem<V>>
  selectedValue: V
  onClick(value: V): void
}

/**
 * The status tab bar that sits directly above a table, ported from apps/dashboard's
 * `TableTabs`. White strip with the card's top radius; the filter row and grid stack under it.
 */
const TableTabsComponent = <V extends string>({ tabs, selectedValue, onClick }: Props<V>) => {
  return (
    <div role="tablist" css={tw`flex w-full overflow-hidden rounded-t-lg bg-shades-0`}>
      {tabs.map((tab) => {
        const isSelected = tab.value === selectedValue

        return (
          <TableTab<V>
            key={tab.value}
            title={tab.title}
            value={tab.value}
            icon={tab.renderIcon(isSelected)}
            subtitle={tab.subtitle}
            selected={isSelected}
            onClick={onClick}
            dataTestId={tab.dataTestId}
          />
        )
      })}
    </div>
  )
}

export const TableTabs = memo(TableTabsComponent) as typeof TableTabsComponent
